import { createContext } from 'react'

export let PatientIdContext = createContext<string | undefined>(undefined)
